import React from 'react';

export interface InfoAlertProps {
  title: string;
  description: string;
  icon?: React.ReactNode;
  variant?: 'info' | 'warning' | 'success' | 'error';
  className?: string;
}

const variantStyles = {
  info: {
    bg: 'bg-blue-50',
    border: 'border-blue-200',
    text: 'text-blue-800',
  },
  warning: {
    bg: 'bg-orange-50',
    border: 'border-orange-200',
    text: 'text-orange-800',
  },
  success: {
    bg: 'bg-green-50',
    border: 'border-green-200',
    text: 'text-green-800',
  },
  error: {
    bg: 'bg-red-50',
    border: 'border-red-200',
    text: 'text-red-800',
  },
};

export const InfoAlert: React.FC<InfoAlertProps> = ({
  title,
  description,
  icon,
  variant = 'warning',
  className = '',
}) => {
  const styles = variantStyles[variant];

  return (
    <div
      className={`${styles.bg} rounded-md p-4 flex flex-col gap-1.5 ${className}`}
    >
      <div className="flex gap-2 items-center">
        {icon && (
          <div className="shrink-0 w-4 h-4 flex items-center">{icon}</div>
        )}
        <p className={`${styles.text} text-base font-semibold`}>{title}</p>
      </div>
      <p className={`${styles.text} text-sm`}>{description}</p>
    </div>
  );
};
